import React from 'react';

import ExportHotelBookingsForm from '~/components/Common/Forms/ExportHotelBookingsForm';
import ContentWithSidebar from '~/components/Finance/ContentWithSidebar';

const DEFAULT_REPORT = 'hotel-bookings';

export const items = [
  {
    title: 'Hotel Bookings (LTLE, LPC & Bedbank)',
    slug: 'hotel-bookings',
    component: ExportHotelBookingsForm,
  },
];

export default function ReportsPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_REPORT} />;
}
